import type { SortField, SortLang, SortType } from '@/types/anime';

export const API_BASE_URL = (
	import.meta.env.VITE_API_BASE_URL ?? 'https://phimapi.com'
).replace(/\/+$/, '');

export const IMAGE_CDN_URL = (
	import.meta.env.VITE_IMAGE_CDN_URL ?? 'https://phimimg.com'
).replace(/\/+$/, '');

/**
 * Anime-only dựa trên TYPE của KKPhim, không phải thể loại:
 *
 * - ANIME_LIST_SLUG: path `/v1/api/danh-sach/hoat-hinh` = kho type hoathinh.
 * - ANIME_MOVIE_TYPE: field `type` trong payload (`"hoathinh"`).
 * - ANIME_CATEGORY_SLUG: thể loại `"hoat-hinh"` — nhiều anime không gắn tag này
 *   (ví dụ One Piece). Không được dùng để lọc tìm kiếm.
 */
export const ANIME_LIST_SLUG = 'hoat-hinh';
export const ANIME_CATEGORY_SLUG = 'hoat-hinh';
export const ANIME_MOVIE_TYPE = 'hoathinh';

export const DEFAULT_PAGE_SIZE = 24;
export const HOME_RAIL_SIZE = 12;
export const HOME_EPISODE_SIZE = 8;

/** KKPhim cho phép tối đa 64 item/trang. */
export const SEARCH_API_PAGE_SIZE = 64;
/** Trần số trang API khi gom kết quả tìm kiếm đã lọc type. */
export const SEARCH_MAX_API_PAGES = 8;

/**
 * "hoat-hinh" bị loại khỏi bộ chips thể loại: mọi phim trong app đều đã là hoạt
 * hình nên chọn nó không lọc được gì.
 */
export const HIDDEN_GENRE_SLUGS = new Set([ANIME_CATEGORY_SLUG]);

export const SORT_OPTIONS: Array<{
	label: string;
	sortField: SortField;
	sortType: SortType;
}> = [
	{ label: 'Mới cập nhật', sortField: 'modified.time', sortType: 'desc' },
	{ label: 'Mới thêm vào kho', sortField: '_id', sortType: 'desc' },
	{ label: 'Năm mới nhất', sortField: 'year', sortType: 'desc' },
	{ label: 'Năm cũ nhất', sortField: 'year', sortType: 'asc' },
];

export const LANG_OPTIONS: Array<{ label: string; value: SortLang }> = [
	{ label: 'Tất cả bản', value: '' },
	{ label: 'Vietsub', value: 'vietsub' },
	{ label: 'Thuyết minh', value: 'thuyet-minh' },
	{ label: 'Lồng tiếng', value: 'long-tieng' },
];

/** API có dữ liệu năm tới tận thập niên 2000; giới hạn danh sách cho gọn UI. */
export const YEAR_OPTIONS = Array.from(
	{ length: new Date().getFullYear() - 1999 },
	(_, index) => String(new Date().getFullYear() - index),
);

export const LIBRARY_STORAGE_PREFIX = 'neko-stream';
export const LIBRARY_MAX_ENTRIES = 60;

export const LIBRARY_LABELS = {
	favorites: 'Yêu thích',
	watchlist: 'Danh sách xem',
	history: 'Lịch sử xem',
} as const;
